import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { stacksApi } from '../../lib/constants';
import { cvToJSON, hexToCV } from '@stacks/transactions';
import { supportednfts } from '../../lib/supportednfts';
import NftCards from './NftCards';

const StyledAccordion = styled(Accordion)(() => ({
    marginTop: '1rem',
    backgroundColor: 'transparent'
}))

const StyleAccordionSummary = styled(AccordionSummary)(() => ({
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px',
    backgroundImage: 'linear-gradient(to right, #F7931A , #6444fe)'
}))

const StyledExpandMoreIcon = styled(ExpandMoreIcon)(() => ({
    color: 'white'
}))

const NftAlbum = ({ authorPrincipal, userSettings }) => {
    const [expanded, setExpanded] = useState(false);
    const [offSet, setOffSet] = useState(0);

    const [selectedAccordion, setSelectedAccordion] = useState(null);

    const [nftAlbum, setNftAlbum] = useState([]);

    const [currentAlbum, setCurrentAlbum] = useState('');
    const [currentAlbumSize, setCurrentAlbumSize] = useState(0);

    const [loadCollections, setLoadCollections] = useState(false);
    const [nftCollections, setNftCollections] = useState([]);

    async function fetchAssetId(currentAlbum, offset) {
        try {
            const response = await axios.get(`${userSettings?.stacksApi || stacksApi}/extended/v1/tokens/nft/holdings?principal=${authorPrincipal}&asset_identifiers=${currentAlbum}&limit=20&offset=${offset}`);
            const { data } = response;
            console.log('API Offset: ', offset);
            console.log('API Response Data: ', data);
            const updatedNftCollections = data.results.map(result => {
                const { value: { hex } } = result;
                const id = cvToJSON(hexToCV(hex)).value;
                return { id, contract: result };
            });
            setNftCollections(prevNftCollections => [...prevNftCollections, ...updatedNftCollections]);
        } catch (error) {
            console.error('Error fetching asset ID:', error);
        }
    };


    const handleAccordionToggle = (selected, currentAlbum, count) => {
        setSelectedAccordion((prevSelected) => (prevSelected === selected ? null : selected));
        setCurrentAlbum(currentAlbum);
        setCurrentAlbumSize(count);
        setExpanded((prevExpanded) => (prevExpanded === selected ? false : true));
        setOffSet(0);
        setNftCollections([]);
        setLoadCollections(true);
    };


    async function initNft() {
        const { data: { non_fungible_tokens } } = await axios.get(`${userSettings?.stacksApi || stacksApi}/extended/v1/address/${authorPrincipal}/balances`);
        for (const key in non_fungible_tokens) {
            const { count } = non_fungible_tokens[key]
            if (Object.keys(supportednfts).includes(key)) {
                setNftAlbum(nftAlbum => [...nftAlbum, { assetId: key, assetName: key.split('::')[1], count: count }]);
            }
        }
    };

    useEffect(() => {
        initNft()
    }, [])

    useEffect(() => {
        if (loadCollections && expanded && currentAlbum) {
            fetchAssetId(currentAlbum, offSet);
            setLoadCollections(false);
        }
    }, [currentAlbum, offSet, loadCollections, expanded]);

    const handleLoadMoreClick = () => {
        console.log('Load More button clicked');
        setOffSet(prevOffset => prevOffset + 20);
        setLoadCollections(true);
    };

    return (
        <>
            {nftAlbum.length > 0 &&
                nftAlbum.map(({ assetId, assetName, count }, i) => {
                    if (parseInt(count) === 0) return null
                    return (
                        <StyledAccordion expanded={selectedAccordion === i ? expanded : false} onChange={() => handleAccordionToggle(i, assetId, count)} key={i}>
                            <StyleAccordionSummary expandIcon={<StyledExpandMoreIcon />} >
                                <Typography variant="h6" color={'white'}>{assetName.toUpperCase()} :: {count}</Typography>
                            </StyleAccordionSummary>
                            <AccordionDetails style={{ display: 'flex', justifyContent: 'center' }}>
                                <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                                    {nftCollections.length > 0 && nftCollections.map(({ id, contract }, i) => {
                                        const { imagehostprefix, imagehostsuffix } = supportednfts[assetId];
                                        const imageUrl = `${imagehostprefix}${id}${imagehostsuffix}`;
                                        return <NftCards id={id} imageUrl={imageUrl} contractId={contract.asset_identifier} key={i} authorPrincipal={authorPrincipal} userSettings={userSettings} />
                                    })}
                                </Grid>
                            </AccordionDetails>
                            {/* Load More Button */}
                            {nftCollections.length < currentAlbumSize && (
                                <button className="nft-load-more" onClick={handleLoadMoreClick}>Load More</button>
                            )}
                        </StyledAccordion>
                    )
                })
            }
        </>
    )
}

export default NftAlbum;